const step_up = {
    verify_your_identity: 'Verify your identity',
    choose_method_description: 'To continue, confirm it’s you with one of the following methods.',
    password: 'Password',
    password_description: 'Enter your account password',
    subject_proof_description: 'To continue, confirm it’s you through an account linked to yours. You can then set up a verification method.',
    no_method_available: 'No verification method available',
    no_method_available_description: 'Your account has no method that can complete this verification. Please contact your administrator for assistance.',
};
export default Object.freeze(step_up);
